import { Form, Formik } from 'formik';
import React from 'react';

import Button from '@components/Button';
import { TextField } from '@components/FormFields';
import { useUserInfoUpdate } from '@hooks';

import schema from './schema';
import styles from './styles.module.css';

interface InitialStateProps {
  name: string;
  email: string;
  password?: string;
  passwordConfirmation?: string;
}

const BasicInfoForm = ({
  initialState,
  loginLinkOnly,
  ReadOnlyMode,
}: {
  initialState: InitialStateProps;
  loginLinkOnly: boolean;
  ReadOnlyMode: string;
}) => {
  const { mutate: updateUser } = useUserInfoUpdate();

  const handleSubmit = (values: InitialStateProps) => {
    delete values['passwordConfirmation'];
    updateUser({ user: values });
  };

  return (
    <Formik
      enableReinitialize
      onSubmit={handleSubmit}
      initialValues={initialState}
      validationSchema={schema}
    >
      {(formik) => (
        <Form>
          <TextField name="name" placeholder="Name" />
          <TextField name="email" placeholder="email" />
          {!loginLinkOnly && (
            <>
              <TextField
                name="password"
                placeholder="Password (leave blank if you do not wish to change)"
                type="password"
              />
              <TextField
                name="passwordConfirmation"
                placeholder="Confirm Password"
                type="password"
              />
            </>
          )}
          {!ReadOnlyMode && (
            <div className={styles.submitBtnContainer}>
              <Button
                type="submit"
                variant="primary"
                width="medium"
                disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
              >
                {formik.isSubmitting ? 'Submitting..' : 'Submit'}
              </Button>
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default BasicInfoForm;
